<script setup lang="ts">
import {ref} from 'vue';
import {ArrowRight, Clock3, Mail, Menu, Phone, X} from 'lucide-vue-next';
import '@/assets/styles/main.css'

const menuOpen = ref(false);
const closeMenu = () => menuOpen.value = false
</script>
<template>
  <div class="site-shell">
    <div class="demo-ribbon">Unverbindliche Website-Demo · Alle Angaben sind fiktiv</div>
    <div class="topbar">
      <div class="container topbar-inner"><span><Clock3 :size="15"/> Mo–Do 8–18 Uhr · Fr 8–14 Uhr</span>
        <div><a href="tel:+493012345670">
          <Phone :size="15"/>
          030 12345670</a><a href="mailto:praxis@zahnzentrum-demo.de">
          <Mail :size="15"/>
          E-Mail</a></div>
      </div>
    </div>
    <header class="header">
      <div class="container nav-wrap">
        <router-link to="/" class="brand" @click="closeMenu"><span
            class="brand-mark">Z</span><span><strong>Zahnzentrum</strong><small>am Stadtpark</small></span>
        </router-link>
        <button class="menu-button" aria-label="Menü" @click="menuOpen=!menuOpen">
          <X v-if="menuOpen"/>
          <Menu v-else/>
        </button>
        <nav :class="{open:menuOpen}">
          <router-link to="/" @click="closeMenu">Start</router-link>
          <router-link to="/leistungen" @click="closeMenu">Leistungen</router-link>
          <router-link to="/praxis" @click="closeMenu">Praxis</router-link>
          <router-link to="/team" @click="closeMenu">Team</router-link>
          <router-link to="/karriere" @click="closeMenu">Karriere</router-link>
          <router-link to="/kontakt" @click="closeMenu">Kontakt</router-link>
         <!-- <router-link to="/termin-buchen" class="nav-cta" @click="closeMenu">Online buchen
            <ArrowRight :size="17"/>
          </router-link>-->
        </nav>
      </div>
    </header>
    <main>
      <router-view v-slot="{Component}">
        <transition name="page" mode="out-in">
          <component :is="Component"/>
        </transition>
      </router-view>
    </main>
    <footer>
      <div class="container footer-inner">
        <div class="brand footer-brand"><span class="brand-mark">Z</span><span><strong>Zahnzentrum</strong><small>am Stadtpark</small></span>
        </div>
        <p>© {{ new Date().getFullYear() }} Musterwebsite · Keine reale Praxis</p>
        <div>
          <router-link to="/impressum">Impressum</router-link>
          <router-link to="/datenschutz">Datenschutz</router-link>
        </div>
      </div>
    </footer>
  </div>
</template>
